// components
import { Grid } from '@interstate/components/Grid';
import { Typography } from '@interstate/components/Typography';

// styles
import { FunctionsRowItemContainer } from './Functions.style';

export interface IFunctionsRowItemProps {
    title: string;
    hotkeysData: Array<{ key: string; value: string }>;
    showLeft: boolean;
    noMarginBottom: boolean;
}

export const FunctionsRowItem = (props: IFunctionsRowItemProps) => {
    const { title, hotkeysData, showLeft, noMarginBottom } = props;

    return (
        <FunctionsRowItemContainer title={title} showLeft={showLeft} noMarginBottom={noMarginBottom}>
            {title && (
                <Typography variant="h6" color="sem.color.on-surface.default" sx={{ marginBottom: '1.125rem' }}>
                    {title}
                </Typography>
            )}
            {hotkeysData.map((item, index) => (
                <Grid key={index} sx={{ display: 'flex', marginBottom: '0.625rem' }}>
                    <Typography variant="body-xs" color="sem.color.on-surface.muted" tag="span" sx={{ width: '5.3125rem' }}>
                        {item.key}
                    </Typography>
                    <Typography variant="body-sm" color="sem.color.on-surface.default" tag="span">
                        {item.value}
                    </Typography>
                </Grid>
            ))}
        </FunctionsRowItemContainer>
    );
};
